import * as React from "react";
const FlyingBook = () => (
  <svg
    id="Layer_4"
    x="0px"
    y="0px"
    viewBox="0 0 47.912918 39.276233"
    xmlSpace="preserve"
    width={47.912918*0.8}
    height={39.276234*0.8}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs53">
      <linearGradient
        id="SVGID_1_-5"
        gradientUnits="userSpaceOnUse"
        x1={50.884701}
        y1={88.200798}
        x2={50.637501}
        y2={70.898201}
        gradientTransform="matrix(-1,0,0,1,168.1284,0)"
      >
        <stop
          offset={0.2665}
          style={{
            stopColor: "#82AEC0",
          }}
          id="stop6-1"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#82AEC0",
            stopOpacity: 0,
          }}
          id="stop7-7"
        />
      </linearGradient>
      <linearGradient
        id="SVGID_2_-1"
        gradientUnits="userSpaceOnUse"
        x1={98.211403}
        y1={84.600998}
        x2={55.399502}
        y2={84.600998}
        gradientTransform="matrix(-1,0,0,1,168.1284,0)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#2F7889",
          }}
          id="stop8-1"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#82AEC0",
          }}
          id="stop9-5"
        />
      </linearGradient>
      <linearGradient
        id="SVGID_3_-2"
        gradientUnits="userSpaceOnUse"
        x1={57.979301}
        y1={84.600998}
        x2={15.2634}
        y2={84.600998}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#2F7889",
          }}
          id="stop10-7"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#82AEC0",
          }}
          id="stop11-6"
        />
      </linearGradient>
      <linearGradient
        id="SVGID_4_-1"
        gradientUnits="userSpaceOnUse"
        x1={10.7527}
        y1={88.200798}
        x2={10.5055}
        y2={70.898102}
      >
        <stop
          offset={0.2665}
          style={{
            stopColor: "#82AEC0",
          }}
          id="stop12-4"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#82AEC0",
            stopOpacity: 0,
          }}
          id="stop13-2"
        />
      </linearGradient>
    </defs>
    <g
      id="layer1"
      style={{
        display: "inline",
      }}
      transform="translate(-46.251708,-44.507682)"
    >
      <g
        id="g56-8-2"
        transform="matrix(1.3853285,-0.19074353,0.23316467,1.4292011,-30.059083,-8.0938824)"
        style={{
          fill: "#0000ff",
        }}
      >
        <path
          style={{
            fontFamily: "Arial",
          }}
          d="m 37.865883,35.106586 q 0,-2.138671 1.148437,-3.345703 1.148438,-1.21289 2.964844,-1.21289 1.189453,0 2.144531,0.568359 0.955078,0.568359 1.453125,1.587891 0.503907,1.013672 0.503907,2.302734 0,1.306641 -0.527344,2.337891 -0.527344,1.03125 -1.494141,1.564453 -0.966797,0.527344 -2.085937,0.527344 -1.212891,0 -2.167969,-0.585938 -0.955078,-0.585937 -1.447266,-1.599609 -0.492187,-1.013672 -0.492187,-2.144532 z m 1.171875,0.01758 q 0,1.552734 0.832031,2.449218 0.837891,0.890625 2.097656,0.890625 1.283203,0 2.109375,-0.902343 0.832032,-0.902344 0.832032,-2.560547 0,-1.048828 -0.357422,-1.828125 -0.351563,-0.785157 -1.03711,-1.212891 -0.679687,-0.433594 -1.529297,-0.433594 -1.207031,0 -2.080078,0.832032 -0.867187,0.826171 -0.867187,2.765625 z m 8.373047,4.166015 v -6.222656 h 0.943359 v 0.873047 q 0.292969,-0.457031 0.779297,-0.732422 0.486328,-0.28125 1.107422,-0.28125 0.691406,0 1.130859,0.287109 0.445313,0.28711 0.626953,0.802735 0.738282,-1.089844 1.921875,-1.089844 0.925782,0 1.423828,0.515625 0.498047,0.509766 0.498047,1.576172 v 4.271484 h -1.048828 v -3.919922 q 0,-0.632812 -0.105469,-0.908203 -0.09961,-0.28125 -0.36914,-0.451172 -0.269531,-0.169922 -0.632813,-0.169922 -0.65625,0 -1.089843,0.439454 -0.433594,0.433593 -0.433594,1.394531 V 39.29018 H 51.10807 v -4.042969 q 0,-0.703125 -0.257812,-1.054687 -0.257813,-0.351563 -0.84375,-0.351563 -0.445313,0 -0.826172,0.234375 -0.375,0.234375 -0.544922,0.685547 -0.169922,0.451172 -0.169922,1.300782 v 3.228515 z m 12.908203,-1.857422 1.042969,-0.164062 q 0.08789,0.626953 0.486328,0.960937 0.404297,0.333985 1.125,0.333985 0.726562,0 1.078125,-0.292969 0.351562,-0.298828 0.351562,-0.697266 0,-0.357422 -0.310547,-0.5625 -0.216797,-0.140625 -1.078125,-0.357422 -1.160156,-0.292968 -1.611328,-0.503906 -0.445312,-0.216797 -0.679687,-0.591797 -0.228516,-0.380859 -0.228516,-0.83789 0,-0.416016 0.1875,-0.767578 0.193359,-0.357422 0.521484,-0.591797 0.246094,-0.181641 0.667969,-0.304688 0.427735,-0.128906 0.914063,-0.128906 0.732422,0 1.283203,0.210937 0.55664,0.210938 0.820312,0.574219 0.263672,0.357422 0.363282,0.960938 l -1.03125,0.140625 q -0.07031,-0.480469 -0.410157,-0.75 -0.333984,-0.269532 -0.949218,-0.269532 -0.726563,0 -1.03711,0.240235 -0.310547,0.240234 -0.310547,0.5625 0,0.205078 0.128907,0.36914 0.128906,0.169922 0.404296,0.28125 0.158204,0.05859 0.931641,0.269532 1.119141,0.298828 1.558594,0.492187 0.445312,0.1875 0.697265,0.550781 0.251954,0.363282 0.251954,0.902344 0,0.527344 -0.310547,0.996094 -0.304688,0.462891 -0.884766,0.720703 -0.580078,0.251953 -1.3125,0.251953 -1.212891,0 -1.851562,-0.503906 -0.632813,-0.503906 -0.808594,-1.494141 z m 6.427734,-5.519531 v -1.212891 h 1.054688 v 1.212891 z m 0,7.376953 v -6.222656 h 1.054688 v 6.222656 z m 6.697266,0 v -0.785156 q -0.591797,0.925781 -1.740235,0.925781 -0.74414,0 -1.371093,-0.410156 -0.621094,-0.410156 -0.966797,-1.142578 -0.339844,-0.738281 -0.339844,-1.69336 0,-0.93164 0.310547,-1.6875 0.310547,-0.761718 0.931641,-1.166015 0.621093,-0.404297 1.388671,-0.404297 0.5625,0 1.001954,0.240234 0.439453,0.234375 0.714843,0.615235 v -3.082032 h 1.048828 v 8.589844 z m -3.333985,-3.105469 q 0,1.195313 0.503907,1.78711 0.503906,0.591797 1.189453,0.591797 0.691406,0 1.171875,-0.5625 0.486328,-0.56836 0.486328,-1.728516 0,-1.277344 -0.492188,-1.875 -0.492187,-0.597656 -1.21289,-0.597656 -0.703125,0 -1.177735,0.574219 -0.46875,0.574218 -0.46875,1.810546 z m 10.03125,2.337891 q -0.585937,0.498047 -1.130859,0.703125 -0.539062,0.205078 -1.160156,0.205078 -1.025391,0 -1.576172,-0.498047 -0.550781,-0.503906 -0.550781,-1.283203 0,-0.457031 0.205078,-0.832031 0.210937,-0.380859 0.544922,-0.609375 0.339843,-0.228516 0.761718,-0.345703 0.310547,-0.08203 0.9375,-0.158203 1.277344,-0.152344 1.88086,-0.363282 0.0059,-0.216796 0.0059,-0.27539 0,-0.644531 -0.298828,-0.908203 -0.404297,-0.357422 -1.201172,-0.357422 -0.74414,0 -1.101562,0.263672 -0.351563,0.257812 -0.521485,0.919922 l -1.03125,-0.140625 q 0.140625,-0.66211 0.462891,-1.066407 0.322266,-0.410156 0.931641,-0.626953 0.609375,-0.222656 1.412109,-0.222656 0.796875,0 1.294922,0.1875 0.498047,0.1875 0.732422,0.474609 0.234375,0.28125 0.328125,0.714844 0.05273,0.269531 0.05273,0.972656 v 1.40625 q 0,1.470703 0.06445,1.863282 0.07031,0.386718 0.269531,0.74414 h -1.101562 q -0.164063,-0.328125 -0.210938,-0.767578 z m -0.08789,-2.355469 q -0.574219,0.234375 -1.722656,0.398438 -0.650391,0.09375 -0.919922,0.210937 -0.269532,0.117188 -0.416016,0.345703 -0.146484,0.222657 -0.146484,0.498047 0,0.421875 0.316406,0.703125 0.322266,0.28125 0.9375,0.28125 0.609375,0 1.083984,-0.263672 0.47461,-0.269531 0.697266,-0.732421 0.169922,-0.357422 0.169922,-1.054688 z m 2.701172,3.123047 v -6.222656 h 0.949218 v 0.884766 Q 84.38932,32.9269 85.684242,32.9269 q 0.5625,0 1.03125,0.205078 0.47461,0.199219 0.708985,0.527344 0.234375,0.328125 0.328125,0.779297 0.05859,0.292968 0.05859,1.02539 v 3.826172 h -1.054687 v -3.785156 q 0,-0.644531 -0.123047,-0.960938 -0.123047,-0.322265 -0.439453,-0.509765 -0.310547,-0.19336 -0.732422,-0.19336 -0.673828,0 -1.166016,0.427735 -0.486328,0.427734 -0.486328,1.623047 v 3.398437 z"
          id="text55-2-2"
          transform="rotate(0.084964)"
          aria-label="Om sidan"
        />
        <rect
          style={{
            fill: "#0000ff",
          }}
          id="rect56-5-6"
          width={49.947067}
          height={1.2409209}
          x={38.158318}
          y={40.329929}
        />
      </g>
      <g
        id="g53-8"
        transform="matrix(0.37026726,-0.04142434,0.05648594,0.43406767,42.317747,38.330912)"
        style={{
          display: "inline",
        }}
      >
        <path
          style={{
            fill: "#803300",
          }}
          d="m 70.24,100.79 48.55,4.62 c 4.57,0.44 5.74,-2.11 5.74,-4.27 L 124.48,98.52 64.77,90.1 c 0,2.99 2.43,10.69 5.47,10.69 z"
          id="path1-5"
        />
        <path
          style={{
            fill: "#ffb380",
          }}
          d="m 72.01,98.51 7.64,0.67 40.91,3.95 c 2.2,0 3.97,-1.75 3.97,-3.91 l -2.17,-66.26 c 0,-2.16 -1.78,-3.91 -3.97,-3.91 L 72.01,24.67 c -3.04,0 -5.51,2.43 -5.51,5.42 v 63 c 0,2.99 2.46,5.42 5.51,5.42 z"
          id="path2-7"
        />
        <path
          style={{
            fill: "#803300",
          }}
          d="m 57.76,100.79 -48.55,4.62 c -4.57,0.44 -5.74,-2.11 -5.74,-4.27 l 0.05,-2.62 59.71,-8.43 c 0,3 -2.43,10.7 -5.47,10.7 z"
          id="path3-6"
        />
        <path
          style={{
            fill: "#ffb380",
          }}
          d="m 55.99,98.51 -7.58,0.67 -40.97,3.96 c -2.2,0 -3.97,-1.75 -3.97,-3.91 L 5.64,32.97 c 0,-2.16 1.78,-3.91 3.97,-3.91 l 46.38,-4.38 c 3.04,0 5.51,2.43 5.51,5.42 v 63 c 0,2.98 -2.46,5.41 -5.51,5.41 z"
          id="path4-1"
        />
        <path
          style={{
            fill: "#424242",
          }}
          d="M 78.75,83.68 H 49.27 l -0.9,15.53 9.2,0.86 c 0,0 1.97,4.92 6.43,4.92 4.46,0 6.43,-4.92 6.43,-4.92 l 9.2,-0.86 z"
          id="path5-8"
        />
        <line
          style={{
            fill: "none",
            stroke: "#616161",
            strokeWidth: 2.5,
            strokeMiterlimit: 10,
          }}
          x1={79.540001}
          y1={100.43}
          x2={70.970001}
          y2={99.690002}
          id="line5-9"
        />
        <line
          style={{
            fill: "none",
            stroke: "#616161",
            strokeWidth: 2.5,
            strokeMiterlimit: 10,
          }}
          x1={48.459999}
          y1={100.43}
          x2={57.029999}
          y2={99.690002}
          id="line6-2"
        />
        <path
          style={{
            fill: "#94c6d6",
          }}
          d="m 119.65,32.82 -4,-5.5 -51.65,58.7 -51.65,-58.7 -4,5.5 -0.56,65.35 c 0,0 10.62,1.33 24.81,-0.11 12.36,-1.25 18.18,-4.45 22.31,-3.62 4.96,1 5.86,4.05 6.02,4.57 0.45,1.44 1.34,2.56 3.07,2.56 1.73,0 2.5,-0.6 3.03,-2.38 0.16,-0.52 1.1,-3.74 6.06,-4.74 4.13,-0.83 9.95,2.37 22.31,3.62 14.19,1.44 24.81,0.11 24.81,0.11 z"
          id="path6-7"
        />
        <path
          style={{
            fill: "url(#SVGID_1_-5)",
          }}
          d="m 114.3,91.87 0.16,-26.39 h 5.47 l 0.28,32.69 c 0,0 -4.35,-1.69 -5.91,-6.3 z"
          id="path7-9"
        />
        <path
          style={{
            fill: "url(#SVGID_2_-1)",
          }}
          d="m 114.55,76.49 -0.25,15.39 c 0,0 -11.96,-0.62 -31.01,-3.92 C 70.83,85.8 64,92.72 64,92.72 L 63.89,76.49 Z"
          id="path9-5"
        />
        <path
          style={{
            fill: "url(#SVGID_3_-2)",
          }}
          d="m 13.45,76.49 0.25,15.39 c 0,0 11.96,-0.62 31.01,-3.92 C 57.17,85.8 64,92.72 64,92.72 L 63.89,76.49 Z"
          id="path11-4"
        />
        <path
          style={{
            fill: "url(#SVGID_4_-1)",
          }}
          d="M 13.7,91.87 13.54,65.48 H 8.06 L 7.79,98.17 c 0,0 4.34,-1.69 5.91,-6.3 z"
          id="path13-3"
        />
        <path
          style={{
            fill: "#f5f5f5",
          }}
          d="m 115.65,27.32 c 0,0 -26.54,-4.99 -38.19,-5.64 C 66.5,21.07 64.25,26.65 64.03,27.32 H 63.99 C 63.76,26.65 61.51,21.08 50.55,21.68 38.9,22.33 12.36,27.32 12.36,27.32 l -1.18,64.4 c 0,0 31.6,-6.62 39.25,-5.76 7.65,0.86 13.57,6.76 13.57,6.76 0,0 0,-0.01 0,-0.01 v 0.01 c 0,0 5.93,-5.9 13.58,-6.76 7.65,-0.86 39.25,5.76 39.25,5.76 z"
          id="path14-1"
        />
        <path
          style={{
            opacity: 0.26,
            fill: "#94c6d6",
          }}
          d="m 53.62,21.69 -5.4,64.2 c 0.85,-0.02 1.6,0 2.2,0.07 7.64,0.85 13.58,6.76 13.58,6.76 l -0.17,-65.4 c 0,0 -1.3,-5.12 -10.21,-5.63 z"
          id="path15-2"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 25.31,30.18 c -2.7,0.47 -4.91,0.87 -6.17,1.09 0,0.62 0,1.3 -0.01,2.03 1.11,-0.2 3.37,-0.61 6.18,-1.1 z"
          id="path16-3"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 49.65,26.96 v 1.99 c 5.33,-0.01 8.28,1.33 9.25,1.87 0,-0.83 0.01,-1.57 0.01,-2.22 -1.65,-0.74 -4.67,-1.65 -9.26,-1.64 z"
          id="path17-3"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 45.31,27.21 c -4.33,0.44 -10.36,1.36 -15.66,2.24 v 2.03 c 5.26,-0.87 11.3,-1.8 15.66,-2.26 z"
          id="path18-4"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 34.66,35.84 c -6.46,1 -12.94,2.16 -15.54,2.63 0,0.66 0,1.34 0,2.03 2.26,-0.41 8.89,-1.61 15.54,-2.64 z"
          id="path19-1"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 46.69,34.28 c -2.11,0.17 -4.8,0.51 -7.69,0.91 v 2.02 c 2.95,-0.42 5.71,-0.76 7.85,-0.94 7.18,-0.59 10.97,1.17 12.03,1.77 0,-0.77 0,-1.51 0,-2.23 -1.96,-0.87 -5.89,-2.05 -12.19,-1.53 z"
          id="path20-1"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 26.38,44.39 c -3.16,0.54 -5.8,1.01 -7.26,1.28 0,0.67 0,1.35 0,2.03 1.31,-0.24 3.99,-0.72 7.26,-1.28 z"
          id="path21-3"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 58.88,43.04 c -1.95,-0.88 -5.89,-2.08 -12.25,-1.55 -4.07,0.33 -10.3,1.26 -15.91,2.18 v 2.03 c 5.66,-0.93 11.98,-1.87 16.08,-2.21 7.3,-0.6 11.1,1.23 12.08,1.8 0,-0.77 0,-1.51 0,-2.25 z"
          id="path22-8"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="M 58.89,50.27 C 56.96,49.39 53,48.16 46.59,48.69 c -0.65,0.05 -1.35,0.12 -2.09,0.2 v 2.01 c 0.81,-0.09 1.56,-0.16 2.26,-0.22 7.44,-0.61 11.24,1.3 12.14,1.84 -0.01,-0.75 -0.01,-1.5 -0.01,-2.25 z"
          id="path23-7"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 40.15,49.43 c -7.82,1.07 -17.56,2.8 -21.02,3.43 0,0.68 0,1.35 0,2.03 3.05,-0.56 13.02,-2.35 21.02,-3.45 z"
          id="path24-4"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 28.25,58.47 c -3.93,0.66 -7.33,1.27 -9.12,1.59 0,0.68 0,1.36 0,2.03 1.62,-0.3 5.07,-0.92 9.12,-1.6 z"
          id="path25-2"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 58.9,57.51 c -1.91,-0.88 -5.89,-2.14 -12.36,-1.61 -3.6,0.3 -8.88,1.05 -13.94,1.86 v 2.02 c 5.11,-0.82 10.48,-1.59 14.1,-1.89 7.63,-0.63 11.44,1.41 12.2,1.87 0,-0.75 0,-1.5 0,-2.25 z"
          id="path26-7"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="M 58.92,71.98 C 57.1,71.11 53.16,69.8 46.66,70.29 v 2.01 c 8.29,-0.67 12.05,1.81 12.26,1.96 0,-0.74 0,-1.5 0,-2.28 z"
          id="path27-7"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 26.38,73.18 c -3.08,0.53 -5.7,0.99 -7.23,1.27 0,0.7 0,1.37 0,2.03 1.41,-0.26 4.05,-0.73 7.23,-1.28 z"
          id="path28-9"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 30.72,72.46 v 2.03 c 3.88,-0.63 8.05,-1.27 11.6,-1.72 v -2.02 c -3.53,0.44 -7.7,1.07 -11.6,1.71 z"
          id="path29-3"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 37.67,78.58 c -7.16,1.04 -15.21,2.47 -18.51,3.07 0,0.74 0,1.42 0,2.03 2.99,-0.55 11.19,-2.01 18.51,-3.08 z"
          id="path30-1"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 58.93,79.22 c -1.81,-0.88 -5.84,-2.25 -12.56,-1.7 -1.27,0.1 -2.75,0.27 -4.36,0.47 V 80 c 1.67,-0.21 3.21,-0.38 4.52,-0.49 8.56,-0.71 12.32,1.95 12.36,1.97 l 0.05,-0.06 c 0,-0.69 0,-1.42 -0.01,-2.2 z"
          id="path31-9"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 36.18,64.4 c -6.82,1.02 -14.05,2.31 -17.04,2.86 0,0.69 0,1.36 0,2.03 2.68,-0.49 10.05,-1.81 17.04,-2.87 z"
          id="path32-8"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 58.91,64.74 c -1.88,-0.88 -5.87,-2.18 -12.43,-1.64 -1.68,0.14 -3.73,0.38 -5.95,0.68 v 2.02 c 2.29,-0.31 4.4,-0.56 6.12,-0.7 7.88,-0.65 11.69,1.54 12.27,1.91 -0.01,-0.74 -0.01,-1.5 -0.01,-2.27 z"
          id="path33-6"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 88.41,29.71 c 8.28,1.1 19.1,3.06 22.04,3.59 0,-0.74 0,-1.41 -0.01,-2.03 C 107,30.64 96.47,28.76 88.4,27.69 v 2.02 z"
          id="path34-5"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 84.06,27.19 c -0.43,-0.04 -0.84,-0.08 -1.23,-0.11 -6.27,-0.52 -10.19,0.65 -12.16,1.52 0,0.65 0.01,1.4 0.01,2.22 1.12,-0.62 4.91,-2.33 11.99,-1.75 0.44,0.04 0.91,0.08 1.39,0.13 z"
          id="path35-0"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 102.36,39.08 c 3.67,0.63 6.71,1.17 8.1,1.43 0,-0.7 0,-1.37 0,-2.03 -1.57,-0.29 -4.55,-0.82 -8.1,-1.42 z"
          id="path36-2"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="M 98.02,36.33 C 92.61,35.46 86.77,34.6 82.89,34.28 c -6.3,-0.52 -10.23,0.66 -12.2,1.53 0,0.72 0,1.46 0,2.23 1.06,-0.6 4.85,-2.36 12.03,-1.77 3.91,0.32 9.84,1.2 15.29,2.08 v -2.02 z"
          id="path37-8"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 97.18,43.39 v 2.02 c 5.81,0.93 11.22,1.91 13.28,2.29 0,-0.69 0,-1.36 0,-2.03 -2.33,-0.42 -7.64,-1.37 -13.28,-2.28 z"
          id="path38-6"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 88.4,49.3 c -2.01,-0.26 -3.87,-0.48 -5.41,-0.6 -6.41,-0.53 -10.37,0.7 -12.3,1.58 0,0.75 0,1.5 0,2.25 0.9,-0.53 4.71,-2.45 12.14,-1.84 1.58,0.13 3.5,0.35 5.57,0.63 z"
          id="path39-0"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 92.75,49.91 v 2.02 c 7.25,1.08 15.06,2.49 17.7,2.97 0,-0.68 0,-1.36 0,-2.03 -2.98,-0.55 -10.63,-1.91 -17.7,-2.96 z"
          id="path40-2"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 93.63,57.24 c -3.95,-0.6 -7.78,-1.11 -10.58,-1.34 -6.48,-0.53 -10.46,0.73 -12.36,1.61 0,0.75 0,1.51 0,2.26 0.76,-0.47 4.57,-2.5 12.2,-1.87 2.83,0.23 6.74,0.76 10.75,1.37 v -2.03 z"
          id="path41-4"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 97.97,57.92 v 2.03 c 5.44,0.88 10.42,1.78 12.47,2.15 0,-0.67 0,-1.35 0,-2.03 -2.28,-0.42 -7.18,-1.3 -12.47,-2.15 z"
          id="path42-8"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 105.04,66.3 v 2.03 c 2.36,0.41 4.29,0.76 5.39,0.96 0,-0.67 0,-1.35 0,-2.03 -1.2,-0.22 -3.1,-0.56 -5.39,-0.96 z"
          id="path43-6"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="M 89.29,71.01 C 87,70.7 84.88,70.45 83.16,70.31 76.52,69.76 72.51,71.1 70.67,71.98 c 0,0.78 0,1.54 0,2.28 0.21,-0.15 3.99,-2.65 12.34,-1.96 1.76,0.14 3.94,0.4 6.3,0.72 v -2.01 z"
          id="path44-5"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 93.63,71.63 v 2.02 c 6.88,1.04 14.1,2.34 16.8,2.83 0,-0.66 0,-1.34 0,-2.03 -3,-0.54 -10.08,-1.8 -16.8,-2.82 z"
          id="path45-0"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 97.18,79.38 c -5.07,-0.81 -10.37,-1.57 -13.97,-1.87 -6.73,-0.55 -10.75,0.83 -12.56,1.7 0,0.78 0,1.51 0,2.2 l 0.05,0.06 c 0.03,-0.02 3.79,-2.68 12.36,-1.97 3.63,0.3 9.02,1.08 14.14,1.9 v -2.02 z"
          id="path46-9"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 101.53,80.1 v 2.03 c 3.89,0.65 7.21,1.25 8.89,1.56 0,-0.61 0,-1.29 0,-2.03 -1.83,-0.34 -5.11,-0.93 -8.89,-1.56 z"
          id="path47-0"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 82.93,63.09 c -6.46,-0.51 -10.4,0.78 -12.26,1.65 0,0.76 0,1.52 0,2.27 0.58,-0.37 4.38,-2.56 12.26,-1.91 z"
          id="path48-0"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 87.28,63.55 v 2.01 c 4.12,0.52 9.07,1.3 13.42,2.02 v -2.03 c -4.38,-0.72 -9.33,-1.49 -13.42,-2 z"
          id="path49-6"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 79.72,41.37 c -4.48,0.03 -7.43,0.95 -9.02,1.67 0,0.74 0,1.48 0,2.24 0.84,-0.48 3.71,-1.87 9.02,-1.92 z"
          id="path50-1"
        />
        <path
          style={{
            opacity: 0.5,
            fill: "#757575",
          }}
          d="m 84.06,41.59 v 2.01 c 2.49,0.25 5.58,0.67 8.77,1.14 v -2.02 c -3.2,-0.48 -6.28,-0.89 -8.77,-1.13 z"
          id="path51-3"
        />
        <path
          style={{
            fill: "#616161",
          }}
          d="m 71.16,98.45 c -1.12,-0.1 -2.15,0.59 -2.51,1.66 -0.54,1.63 -1.8,3.76 -4.65,3.76 -2.88,0 -4.15,-2.14 -4.7,-3.77 -0.36,-1.05 -1.37,-1.73 -2.48,-1.64 l -0.39,0.03 0.01,0.32 c 0,4.17 3.38,7.55 7.55,7.55 4.17,0 7.55,-3.38 7.55,-7.55 0,-0.1 -0.01,-0.33 -0.01,-0.33 z"
          id="path52-8"
        />
      </g>
      <g
        style={{
          display: "inline",
          fill: "#000000",
        }}
        id="g57"
        transform="matrix(0.03,0,0,0.03,61.331722,113.2691)"
      >
        <path
          id="path1-4"
          d="m 422.31007,-960 c -22,0 -40.8177,7.84897 -56.48437,23.51562 C 350.15903,-920.81771 342.31007,-902 342.31007,-880 c 0,22 7.84896,40.81771 23.51563,56.48438 15.66665,15.66665 34.48437,23.51562 56.48437,23.51562 22,0 40.89583,-7.84897 56.5625,-23.51562 15.66667,-15.66667 23.4375,-34.48438 23.4375,-56.48438 0,-22 -7.77083,-40.81771 -23.4375,-56.48438 C 463.2059,-952.15103 444.31007,-960 422.31007,-960 Z m -262.96875,12.73438 c -11.33333,0 -20.84896,3.8177 -28.51562,11.48437 -7.66667,7.66667 -11.48438,17.18228 -11.48438,28.51563 v 122.03124 c 0,8 2.15104,15.15105 6.48438,21.48438 4.33332,6.33333 10.16666,11.11979 17.5,14.45312 l 121.95312,52.8125 -0.46875,7.5 L 200.74757,-365 48.794435,-397.03125 c -11.33331,-2.66667 -21.68229,-0.78644 -31.01562,5.54687 -9.3333296,6.33335 -15.0312496,15.15105 -17.03124962,26.48438 -1.99999998,11.33333 0.0156,21.6823 6.01563002,31.01562 5.9999996,9.33334 14.6822896,14.95313 26.0156196,16.95313 l 197.968755,40 c 10.66667,2 20.53125,0.19792 29.53125,-5.46875 9,-5.66667 14.83333,-13.86458 17.5,-24.53125 L 308.79444,-445 l 83.98438,80 v 200 c 0,11.33333 3.81771,20.84896 11.48438,28.51563 7.66665,7.66666 17.18229,11.48437 28.51562,11.48437 11.33333,0 20.84897,-3.81771 28.51562,-11.48437 7.66667,-7.66667 11.48438,-17.1823 11.48438,-28.51563 v -242.96875 c 0,-5.33333 -0.96875,-10.54687 -2.96875,-15.54687 -2,-5.00001 -5.0625,-9.51563 -9.0625,-13.51563 L 388.79444,-505 l 2.5,-20.23438 28.75,-145.39062 46.79688,17.8125 c 0.21261,-0.0273 0.46961,-0.0649 0.70312,-0.0781 h 0.0781 0.0781 c 8.7804,5.14338 21.29742,8.09525 34.45312,8.125 15.87305,-0.0243 30.62771,-4.29458 39.14062,-11.32813 h 0.0781 l 2.65625,-0.3125 -0.46875,-1.17187 L 635.74757,-735 c 8.68184,-7.28492 13.50816,-16.30831 14.45313,-27.10938 0.94497,-10.80106 -2.16822,-20.53692 -9.45313,-29.21874 -7.28491,-8.68183 -16.38645,-13.50816 -27.1875,-14.45313 -10.80103,-0.94497 -20.53691,2.24633 -29.21875,9.53125 l -55.625,46.71875 c -9.39186,4.99048 -19.0741,9.07904 -29.0625,12.26563 -5.59278,-0.0113 -11.46484,0.0273 -17.65625,0.15624 l -66.25,-35.23437 v -0.0781 c -6.54572,-8.63689 -14.5607,-15.80358 -23.98437,-21.5625 C 379.76319,-801.31774 366.77882,-805 352.77882,-805 c -9.33333,0 -19.46875,1.53125 -30.46875,4.53125 -10.83208,2.9542 -27.98951,9.39849 -50.78125,19.14063 l -0.15625,-1.95313 -72.03125,-27.96875 v -96.01562 c 0,-11.33335 -3.81769,-20.84896 -11.48438,-28.51563 -7.66666,-7.66667 -17.18229,-11.48437 -28.51562,-11.48437 z"
        />
      </g>
    </g>
  </svg>
);
export default FlyingBook;
